<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapActions, mapGetters } from "vuex";
import authApi from "@/api/auth";

export default {
  methods: {
    ...mapActions("channelStore", {
      listAllChannel: "listAllChannel",
    }),
    ...mapActions("declareEnterpriseStore", {
      listAllDeclareEnterprise: "listAllDeclareEnterprise",
    }),
    ...mapActions("merchantStore", {
      listAllMerchant: "listAllMerchant",
    }),
    ...mapActions("shopAuthStore", {
      listShopAuthorize: "list",
    }),
    ...mapActions(["portList", "initData"]),
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    window.PDD_OPEN_init({}, function() {
      // 初始化已完成
      window
        .PDD_OPEN_getPati()
        .then(function(pati) {
          // 使用 pati
          console.log(pati);
          localStorage.setItem("pdd_pati", pati);
          authApi.getIsvPageCode(location.href).then((res) => {
            try {
              const data = JSON.parse(res.value);
              localStorage.setItem("pdd_pageCode", data.response.pageCode);
            } catch (e) {
              console.log(e);
            }
          });
        })
        .catch((error) => console.log(error));
    });
  },
  watch: {
    $route: {
      handler(val) {
        const code = this.$route.query.code;
        const platform = this.$route.query.platform;
        if (code) {
          if (platform === "douYin") {
            authApi.authDouYinCode(code).then((res) => {
              if (res.val) {
                Message.success({
                  message: "授权成功",
                });
                if (val.name == "shopAuthView") {
                  this.listShopAuthorize();
                }
              }
            });
          } else if (platform === "JD") {
            authApi
              .authJDCode(code)
              .then((res) => {
                if (res.value) {
                  Message.success({
                    message: "授权成功",
                  });
                  if (val.name == "shopAuthView") {
                    this.listShopAuthorize();
                  }
                }
              })
              .catch((res) => {
                Message.error({
                  message: "授权失败:" + res.msg,
                });
              });
          } else {
            authApi
              .authPinduoduoCode(code)
              .then((res) => {
                if (res.value) {
                  Message.success({
                    message: "授权成功",
                  });
                  if (val.name == "shopAuthView") {
                    this.listShopAuthorize();
                  }
                }
              })
              .catch((res) => {
                Message.error({
                  message: "授权失败：" + res.msg,
                });
              });
          }
        }
        if (this.user) {
          this.initData();
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
